function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

document.addEventListener("DOMContentLoaded", function () {
  var forms = document.querySelectorAll(".c-form-stepper");
  forms.forEach(function (form) {
    var steps = form.querySelectorAll(".c-form-stepper__form-step");
    var nextBtns = form.querySelectorAll(".next-step");
    var prevBtns = form.querySelectorAll(".prev-step");
    var currentStep = 0;
    nextBtns.forEach(function (btn) {
      btn.addEventListener("click", function () {
        if (validateStep()) {
          steps[currentStep].classList.remove("active");
          currentStep++;

          if (currentStep < steps.length) {
            steps[currentStep].classList.add("active");
          }
        }
      });
    });
    prevBtns.forEach(function (btn) {
      btn.addEventListener("click", function () {
        steps[currentStep].classList.remove("active");
        currentStep--;
        steps[currentStep].classList.add("active");
      });
    });

    function validateStep() {
      var stepIsValid = true;
      var currentInputs = steps[currentStep].querySelectorAll("input");
      currentInputs.forEach(function (input) {
        if (!input.checkValidity()) {
          input.reportValidity();
          stepIsValid = false;
        }
      });

      if (stepIsValid) {
        steps[currentStep].classList.add("valid-step");
      }

      return stepIsValid;
    }

    steps.forEach(function (step) {
      var inputs = step.querySelectorAll("input");
      inputs.forEach(function (input) {
        input.addEventListener("input", function () {
          var allFilled = _toConsumableArray(inputs).every(function (input) {
            return input.value.trim() !== "";
          });

          if (allFilled) {
            step.classList.add("is-filled");
          } else {
            step.classList.remove("is-filled");
          }
        });
      });
    });
    steps.forEach(function (step, index) {
      if (index !== currentStep) {
        step.classList.remove("active");
      } else {
        step.classList.add("active");
      }
    }); // const params = new URLSearchParams(window.location.search);
    // if (params.get("newsletter") === "success") {
    //   setTimeout(() => {
    //     const form = document.querySelector(".c-form-stepper");
    //     if (form) {
    //       const offset = 100;
    //       const top =
    //         form.getBoundingClientRect().top + window.scrollY - offset;
    //       window.scrollTo({ top, behavior: "smooth" });
    //     }
    //   }, 100);
    // }
  });
});